function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "200",
  height: "108",
  viewBox: "0 0 200 108",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.258 76.333L0 108h200l-70.968-82.334-70.967 76.001-25.807-25.334z",
  fill: "#FAF9F8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.258 76.333L0 108h200l-70.968-82.334-70.967 76.001-25.807-25.334z",
  fill: "url(#paint0_linear)"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "hard-light"
  },
  filter: "url(#filter1_i)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.258 76.333L0 108h200l-70.968-82.334-70.967 76.001-25.807-25.334z",
  fill: "gray"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_b)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "58",
  cy: "20",
  r: "20",
  fill: "#FAF9F8"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "58",
  cy: "20",
  r: "20",
  fill: "url(#paint1_linear)"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "hard-light"
  },
  filter: "url(#filter3_i)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "58",
  cy: "20",
  r: "20",
  fill: "gray"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_b",
  x: "-2",
  y: "23.666",
  width: "204",
  height: "86.334",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: "1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_i",
  x: "0",
  y: "25.666",
  width: "200",
  height: "83.334",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: "1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "1.5"
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: "-1",
  k3: "1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.25098 0 0 0 0 0.25098 0 0 0 0 0.25098 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_b",
  x: "36",
  y: "-2",
  width: "44",
  height: "44",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: "1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_i",
  x: "38",
  y: "0",
  width: "40",
  height: "41",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: "1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "1.5"
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: "-1",
  k3: "1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.25098 0 0 0 0 0.25098 0 0 0 0 0.25098 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: "100",
  y1: "25.666",
  x2: "100",
  y2: "108",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BFBFBF",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#BFBFBF",
  stopOpacity: ".3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: "58",
  y1: "0",
  x2: "58",
  y2: "40",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BFBFBF",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#BFBFBF",
  stopOpacity: ".3"
}))));